import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { UtilsService } from './utils.service';

@Injectable()
export class ExchangesService {
  constructor(
    private http: HttpService,
    private utils: UtilsService,
  ) {}

  getExchanges(page: number = 1, page_size: number = 10) {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('page_size', page_size.toString());

    return new Promise((resolve, reject) => {
      this.http.get(`exchanges`, params).subscribe(
        (resp: any) => {
          resolve(resp);
        },
        (error) => {
          reject(error);
        },
      );
    });
  }

  updateExchangeStatus(
    exchangeId: number,
    status: 'finished' | 'rejected',
    payload?: {
      origin_wallet_id?: string;
      destination_wallet_id?: string;
      note?: string | null;
    },
  ) {
    const body = {
      status,
      ...(payload || {}),
    };

    return new Promise((resolve, reject) => {
      this.http.patch(`exchange/${exchangeId}/status`, body).subscribe(
        (resp: any) => {
          resolve(resp);
        },
        (error) => {
          reject(error);
        },
      );
    });
  }

  declareExchange(body: any) {
    return new Promise((resolve, reject) => {
      this.http.post('exchange/declare', body).subscribe(
        (resp: any) => {
          resolve(resp);
        },
        (error) => {
          reject(error);
        },
      );
    });
  }
}
